import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';

const AddLeadPlannerToThreadButton = ({
  threadResource,
  onAdd,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { refreshAll } = useMessagesContext();

  const addPlannerToThread = async () => {
    try {
      const [addPlannerToThreadResource] = await threadResource?.relationship(fr.relationships.addLeadPlannerToThread.name).link('related').get();
      await addPlannerToThreadResource.submit();
      await refreshAll();
      onAdd();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <FDSecondaryActionButton
      label={'Add lead planner'}
      size={'sm'}
      onClick={addPlannerToThread}
      test="messages-add-planner-to-thread-button"
    />
  );
};

AddLeadPlannerToThreadButton.defaultProps = {
};

AddLeadPlannerToThreadButton.propTypes = {
  onAdd: PropTypes.func.isRequired,
  threadResource: PropTypes.object.isRequired,
};

export { AddLeadPlannerToThreadButton };
